import { render, staticRenderFns } from "./ExpedicaoDetalhes.vue?vue&type=template&id=27f0105b&scoped=true"
import script from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoDetalhes.vue?vue&type=style&index=0&id=27f0105b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0105b",
  null
  
)

export default component.exports